<!-- Cover Image -->
@if (coverImageSource != null) {
  <div class="relative inline-block max-h-80 w-full overflow-hidden">
    <img src="{{ coverImageSource }}" class="w-full h-[25vh] object-cover" alt="Cover Image" />
  </div>
} @else {
  <div class="relative inline-block h-14 max-h-80 w-full overflow-hidden"></div>
}

<!-- Header Bar -->
<div
  class="fixed top-0 left-0 sm:left-64 right-0 h-14 transition-all duration-250 ease-in-out flex z-20 scroll-appearance"
  [class.bg-gray-50]="isScrolled"
  [class.dark:bg-gray-900]="isScrolled"
  [class.bg-transparent]="!isScrolled"
  [class.no-transition]="!isScrolled"
  [class.shadow-sm]="isScrolled"
>
  <div class="flex justify-between items-center w-full">
    <!-- Left -->
    <div class="flex items-center">
      <!-- Sidebar Toggle -->
      <app-round-button
        [transparent]="coverImageSource === null || isScrolled"
        class="ml-6 my-3 sm:hidden transition-none"
      >
        <app-icon
          (click)="layoutService.toggleSidebar()"
          name="chevron-left"
          fill="none"
          [class.hidden]="layoutService.isSidebarOpen()"
          [stroke]="coverImageSource != null && !isScrolled ? '#fff' : 'currentColor'"
        />
      </app-round-button>
      <!-- Page Title -->
      <div
        class="ml-2 sm:ml-8 transition-all duration-250 ease-in-out"
        [class.opacity-0]="!isScrolled"
        [class.opacity-100]="isScrolled"
        [class.no-transition]="!isScrolled"
      >
        <h1 class="text-md font-regular">
          {{ title }}
        </h1>
      </div>
    </div>
    <!-- Right -->
    <div class="flex gap-4 mx-6 my-3">
      <!-- Share Button -->
      <app-round-button
        [transparent]="coverImageSource === null || isScrolled"
        class="transition-none"
      >
        <div class="w-8 h-8 flex items-center justify-center">
          <app-icon
            name="share"
            fill="none"
            class="w-6 h-6"
            [stroke]="coverImageSource != null && !isScrolled ? '#fff' : 'currentColor'"
          />
        </div>
      </app-round-button>
      <!-- More Button -->
      <app-round-button
        [transparent]="coverImageSource === null || isScrolled"
        class="transition-none"
        (click)="isMoreMenuOpen = !isMoreMenuOpen"
      >
        <app-icon
          name="more"
          [strokeWidth]="2"
          fill="none"
          [stroke]="coverImageSource != null && !isScrolled ? '#fff' : 'currentColor'"
        />
      </app-round-button>
      <!-- Dropdown menu -->
      <div
        id="dropdownMore"
        [class.hidden]="!isMoreMenuOpen"
        class="z-10 absolute top-12 right-6 bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-44 dark:bg-gray-800 dark:divide-gray-600"
      >
        <ul
          class="py-2 text-sm text-gray-700 dark:text-gray-200"
          aria-labelledby="dropdownMenuIconButton"
        >
          <li>
            <a
              (click)="enableEditMode()"
              class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white transition-all cursor-pointer"
              >Edit</a
            >
          </li>
          <li>
            <a
              class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white transition-all cursor-pointer"
              >Placeholder</a
            >
          </li>
        </ul>
        <div class="py-2">
          <a
            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white cursor-pointer"
            >Separated link</a
          >
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Main Content -->
<div class="p-8">
  <!-- Emoji Page Icon and Picker -->
  <app-page-icon-emoji
    [emojiId]="emojiId"
    [isEditable]="isEditing"
    [adjustForCoverImage]="coverImageSource != null"
    (emojiIdChange)="emojiIdChange.emit($event)"
  ></app-page-icon-emoji>

  <!-- Page Title and Actions -->
  <div class="h-8"></div>
  <div class="sticky top-0 bg-gray-50 dark:bg-gray-900 pb-6 flex items-center justify-between">
    <!-- Page Title -->
    @if (isEditing) {
      <app-editable-text
        [(ngModel)]="title"
        (ngModelChange)="titleChange.emit($event)"
        placeholder="Add title..."
        textareaClass="!text-2xl font-bold"
      ></app-editable-text>
    } @else {
      <h1 class="text-2xl font-bold">{{ title }}</h1>
    }
    <!-- Page Actions (e.g. Buttons)-->
    <div class="flex items-center gap-2">
      <ng-content select="[pageActions]"></ng-content>
    </div>
  </div>

  <!-- Actual Page Content -->
  <div class="overflow-hidden">
    <ng-content></ng-content>
  </div>
</div>
